import {DeviceName} from './DeviceName';

export enum PartType {
    Distance = 'distance',
    Duration = 'duration',
    Repetitions = 'repetitions',
    Rest = 'rest',
    OffErg = 'off_erg',
}

export interface DistancePart {
    __uuid: string;
    type: PartType.Distance;
    is_preview: boolean;
    distance_meters: number;
    device_identifier: DeviceName | null;
}

export interface DurationPart {
    __uuid: string;
    type: PartType.Duration;
    is_preview: boolean;
    duration_milliseconds: number;
    device_identifier: DeviceName | null;
}

export interface RepetitionsPart {
    __uuid: string;
    type: PartType.Repetitions;
    is_preview: boolean;
    repetitions: number;
    device_identifier: DeviceName | null;
}

export interface RestPart {
    __uuid: string;
    type: PartType.Rest;
    is_preview: boolean;
    rest_milliseconds: number;
    device_identifier: DeviceName | null;
}

export interface OffErgPart {
    __uuid: string;
    type: PartType.OffErg;
    is_preview: boolean;
    duration_milliseconds: number;
    instruction_text: string;
    device_identifier: DeviceName | null;
}

export type Part = DistancePart | DurationPart | RepetitionsPart | RestPart | OffErgPart;
